import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './stores/actionsList';
import { Route, Switch } from "react-router-dom";

import i18n from 'i18next';
import { siteConfig } from './variables/config'
import { changeUrlWithLng, getObject, getToken, getUserInfo, pathMaker } from './utils/useful'

// import routes from './variables/routes'
import Header from './components/Header'
import Footer from './components/Footer';
// import TabBar from './components/TabBar';
import NotifManager from './components/NotifManager';
import { initSocket, socket } from './utils/socket.services';

// import { io } from "socket.io-client";
// import ProtectedRoute from './components/ProtectedRoute';
import { carbonPages, carbonSections } from './variables/carbonPages';
import { energyPages, energySections } from './variables/energyPages';
import { adminPages, adminSections } from './variables/adminPages';
import HttpServices from './utils/Http.services';
import store from './stores/storeConfig';
import { settingsPages, settingsSections } from './variables/settingsPages';
import StagesManager from './components/StagesManager';
import Home from './pages/Home';
import Profile from './pages/Profile';
// import Admin from './pages/Applet';
import Settings from './pages/Settings';
import Applet from './pages/Applet';
import Dashboard from './pages/Dashboard';
import HomeDashboard from './pages/HomeDashboard';

// import Modal from './components/Modal'
// import './App.css';


class App extends React.Component {

    state = {
        lngRoute: '',
        showPage: true,
        frames: 'dashboard',
        frameObject: {},
        headerSettings: {}

    }



    // socket = null
    componentDidMount() {
        // this.checkUser()
        // this.initConfig()
        // initSocket()
        // this.initCheckLocation()
        if (this.props.user?.loggedin) {
            this.checkDefaultTab()
        } else {
            // console.log("GO TO LOGIN")
            setTimeout(() => {
                let path = '/login'
                window.history.pushState({}, '', path);

            }, 100);

        }


    }


    // initCheckLocation = () => {
    //     let windowPath = this.props.location.pathname.split('/')

    //     // console.log(windowPath)
    //     // windowPath = windowPath[windowPath.length - 1]
    //     // windowPath = windowPath[1]
    //     if (windowPath[1] == 'en') {
    //         store.dispatch(actions.initHeader(windowPath[2]))
    //     } else {

    //         store.dispatch(actions.initHeader(windowPath[1]))
    //     }


    // }

    componentDidUpdate(prevProps) {


        if (this.props.windowData?.path != prevProps.windowData?.path) {
            this.checkDefaultTab()
        }


    }

    checkDefaultTab = () => {
        // console.log(this.props.windowData)
        let page = this.props.windowData?.path[0]

        if (!page) {
            page = ''
        }

        this.stageManager.changeStage(page)

    }




    changeFormObject = (frame, frameValue) => {
        let frames = frame
        let frameObject = frameValue
        this.setState({ frames, frameObject })
    }
    setData = (key, value, cb) => {
        // console.log('ridix key', key)
        // console.log('ridix', value)
        let frameObject = this.state.frameObject
        let frames = this.state.frames
        this.setState({ [key]: value }, () => {
            // console.log('this.state.frames', this.state.frames)

            switch (this.state.frames) {
                case 'document':
                    frameObject.child = Object.values(adminPages)
                    frameObject.section = Object.values(adminSections)
                    break;

                case 'energy':
                    frameObject.child = Object.values(energyPages)
                    frameObject.section = Object.values(energySections)
                    break;

                case 'carbon':
                    frameObject.child = Object.values(carbonPages)
                    frameObject.section = Object.values(carbonSections)
                    break;
                case 'settings':
                    frameObject.child = Object.values(settingsPages)
                    frameObject.section = Object.values(settingsSections)
                    break;
                default:
                    frameObject = {}
                    frames = 'dashboard';
            }
            this.setState({ frameObject }, () => {
                console.log('frameObject', frameObject)
            })
            if (cb) { cb() }
        })
    }






    initConfig() {
        // this.props.actions.changeSetting('hideTabBar', false)

        // SET LANGNGUAGE
        // let parent = this
        i18n.on('languageChanged', (lng) => {
            // this.setState({ showPage: false }, () => {


            if (siteConfig.forceUrl) {
                changeUrlWithLng(lng)
            }
            this.props.actions.changeLanguage('language', lng)
            // window.location.reload();

            //     this.setState({ showPage: true })
            // })

        })
        this.setSize()

        window.addEventListener('resize', this.setSize)

    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.setSize)

    }

    setSize = () => {
        let sizes = { isMobile: false, isTablet: false, isDesktop: false }
        let key = "isDesktop"
        let width = window.innerWidth
        if (width < 768 && width >= 576) {
            key = 'isTablet'
        }
        if (width < 576) {
            key = 'isMobile'
        }

        sizes[key] = true

        for (const [key, value] of Object.entries(sizes)) {
            this.props.actions.changeSetting(key, value)
        }

    }
    initServices = () => {
        // console.log('initServices')
        HttpServices.request('initConfig', {}, (fetchResult, fetchError) => {
            // console.log('fetchERRRRR', fetchError)
            if (fetchError) {
                return
            }
            // console.log('fetchResult', fetchResult)
            store.dispatch(actions.addInbox(fetchResult.inboxes))
        })
    }

    checkUser = (dontShowNotif) => {
        setTimeout(() => {
            // console.log("CHECK USER")
            // console.log(this.props.user.loggedin)
            if (this.props.user.loggedin) {
                if (getToken()) {
                    getUserInfo((data, err, status) => {

                        if (status === 401) {
                            console.log('status 401')
                            return ``
                            this.props.actions.logoutUser()
                        }
                        if (status === 200 && data) {
                            // console.log("DFF")
                            // if (data.authorized) {
                            // console.log(data.user)
                            // console.log('authorized')
                            initSocket()
                            this.initServices()
                            this.props.actions.setUser(data.user, null, true)
                            // } else {
                            //     this.props.actions.logoutUser()
                            // }
                        }

                        if (err) {
                            if (!dontShowNotif) {
                                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.cantConnectToServer', description: '{{lang}}errors.checkYourInternetConnection' })
                            }
                            this.props.actions.setUser({}, null, true)
                            setTimeout(() => {
                                this.checkUser(true)
                            }, 10000);
                        }

                    })
                } else {
                    this.props.actions.logoutUser()
                }
            }
        }, 100);
    }


    setHeader = (key, value) => {

        // console.log(key,value)
        if (typeof key == 'object') {

            this.setState({ headerSettings: key })

        } else {
            // console.log("HERE",{ ...this.state.headerSettings, [key]: value })
            this.setState({ headerSettings: { ...this.state.headerSettings, [key]: value } }, () => {

            })
        }
        // console.log(data)
    }


    render() {


        if (this.state.showPage) {
            return (
                <div className={"container-fluid default-theme m-0 p-0 w-100 " + (this.props.settings.isMobile ? 'mobile' : 'desktop')} >

                    <NotifManager>

                        <div className="d-flex w-100">

                            {/* {this.props.settings.showTabBar && (
                                // <></>
                                <TabBar />
                            )} */}


                            <div style={{ width: '100%', position: 'relative' }}>

                                {this.props.settings.showHeader && (
                                    <Header mainSettings={this.state.headerSettings} changeFormObject={this.changeFormObject} frameObject={this.state.frameObject} setData={this.setData} />
                                )}

                                <div className="w-100" style={{ minHeight: 'calc(100vh - 180px)', backgroundColor: '#fff' }} >

                                    <StagesManager ref={el => this.stageManager = el} fast={true}>

                                        {/* <Home stage={1} stageName={'login'} setHeader={this.setHeader} location={this.props.location} /> */}

                                        <Home stage={1} stageName={''} setHeader={this.setHeader} location={this.props.location} />
                                        {/* <HomeDashboard stage={1} stageName={'admin'} setHeader={this.setHeader} location={this.props.location} /> */}
                                        <Profile stage={1} stageName={'profile'} windowData={this.props.windowData} baseUrl={['profile']} setHeader={this.setHeader} location={this.props.location} />
                                        <Applet stage={1} stageName={'branch'} windowData={this.props.windowData} baseUrl={['branch']} setHeader={this.setHeader} location={this.props.location} />
                                        <Settings stage={1} stageName={'settings'} windowData={this.props.windowData} baseUrl={['settings']} setHeader={this.setHeader} location={this.props.location} />


                                    </StagesManager>

                                </div>



                               

                                {this.props.settings.showFooter && (
                                    <Footer />
                                )}
                            </div>


                        </div>


                    </NotifManager>


                </div>
            )
        } else {
            return (<div></div>)
        }

    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);